class InstagramReels extends HTMLElement {
  constructor() {
    super();
    this.accessToken = this.dataset.accessToken;
    this.limit = parseInt(this.dataset.limit) || 6;
    this.layout = this.dataset.layout || 'grid';
    this.showProductTags = this.dataset.showProductTags === 'true';
  }

  connectedCallback() {
    if (this.accessToken) {
      this.fetchReels();
    }
  }

  async fetchReels() {
    try {
      const response = await fetch(`https://graph.instagram.com/me/media?fields=id,caption,media_type,media_url,thumbnail_url,permalink,timestamp&access_token=${this.accessToken}&limit=${this.limit}`);
      const data = await response.json();
      
      if (data.data && data.data.length) {
        this.renderReels(data.data.filter(item => item.media_type === 'VIDEO'));
      } else {
        this.renderError('No Reels found');
      }
    } catch (error) {
      console.error('Error fetching Instagram Reels:', error);
      this.renderError('Error loading Reels. Please try again later.');
    }
  }

  renderReels(reels) {
    const container = this.querySelector('[data-reels-container]');
    container.innerHTML = '';
    container.classList.add(this.layout);

    reels.forEach(reel => {
      const reelElement = document.createElement('div');
      reelElement.className = 'reel-item';
      
      const video = document.createElement('video');
      video.className = 'reel-video';
      video.src = reel.media_url;
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      
      // Add hover play/pause
      video.addEventListener('mouseenter', () => video.play());
      video.addEventListener('mouseleave', () => {
        video.pause();
        video.currentTime = 0;
      });
      
      // Add click for modal
      video.addEventListener('click', () => this.openModal(reel));
      
      const overlay = document.createElement('div');
      overlay.className = 'reel-overlay';
      
      if (reel.caption) {
        const caption = document.createElement('div');
        caption.className = 'reel-caption';
        caption.textContent = reel.caption.length > 100 ? reel.caption.substring(0, 100) + '...' : reel.caption;
        overlay.appendChild(caption);
      }
      
      // Add product tags if enabled and found in caption
      if (this.showProductTags && reel.caption) {
        const productTags = this.extractProductTags(reel.caption);
        if (productTags.length) {
          const tagsContainer = document.createElement('div');
          tagsContainer.className = 'reel-product-tags';
          
          productTags.forEach(tag => {
            const tagElement = document.createElement('span');
            tagElement.className = 'product-tag';
            tagElement.textContent = tag;
            tagElement.addEventListener('click', (e) => {
              e.stopPropagation();
              this.handleProductTagClick(tag);
            });
            tagsContainer.appendChild(tagElement);
          });
          
          overlay.appendChild(tagsContainer);
        }
      }
      
      reelElement.appendChild(video);
      reelElement.appendChild(overlay);
      container.appendChild(reelElement);
    });
  }

  extractProductTags(caption) {
    // Extract hashtags that might be product references
    const hashtags = caption.match(/#\w+/g) || [];
    return hashtags.map(tag => tag.substring(1)); // Remove the #
  }

  handleProductTagClick(tag) {
    // Search for products matching the tag
    const searchUrl = `/search?q=${encodeURIComponent(tag)}&type=product`;
    window.location.href = searchUrl;
  }

  openModal(reel) {
    const modal = document.createElement('div');
    modal.className = 'reel-modal active';
    
    const modalContent = document.createElement('div');
    modalContent.className = 'reel-modal-content';
    
    const closeButton = document.createElement('span');
    closeButton.className = 'reel-modal-close';
    closeButton.innerHTML = '&times;';
    closeButton.addEventListener('click', () => modal.remove());
    
    const video = document.createElement('video');
    video.className = 'reel-modal-video';
    video.src = reel.media_url;
    video.controls = true;
    video.autoplay = true;
    
    modalContent.appendChild(closeButton);
    modalContent.appendChild(video);
    modal.appendChild(modalContent);
    
    document.body.appendChild(modal);
    document.body.style.overflow = 'hidden';
    
    // Close modal when clicking outside
    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        modal.remove();
        document.body.style.overflow = '';
      }
    });
  }

  renderError(message) {
    const container = this.querySelector('[data-reels-container]');
    container.innerHTML = `<div class="instagram-reels__error">${message}</div>`;
  }
}

customElements.define('instagram-reels', InstagramReels);